import { mainStore } from '~/stores';

import type { AnalyticsProvider } from '../types';

export class ReactNativeProvider implements AnalyticsProvider {
  readonly name = 'reactNative' as const;
  readonly requiresConsent = false;

  isAvailable(): boolean {
    return mainStore.isRN;
  }

  initialize(): void {
    // RN bridge is available through window.ReactNativeWebView, no initialization needed
  }

  track(eventName: string, payload: Record<string, unknown>): void {
    if (!mainStore.isRN) return;
    try {
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({
          targetFunc: 'analytics',
          data: { name: eventName, params: payload },
        }),
      );
    } catch (e) {
      console.error(e);
    }
  }
}
